/**
 * List Schema of ParametroRelatorio
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {ParametroRelatorio} from '@/model/resource/ParametroRelatorio'

/* TODO: review generated schema */
export class ListParametroRelatorioSchema extends Schema {
  readonly name = 'ListParametroRelatorio'

  readonly fieldSet: FieldSet<ParametroRelatorio> = {
    idParametroRelatorioPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    relatorioGeracao: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.relatorioGeracao?.$id,
      },
    }),
    dateBy: (): FieldComponent => ({
      is: Component.Render,
    }),
    cnpjDestinatario: (): FieldComponent => ({
      is: Component.Render,
    }),
    cnpjEmbarcadorTransportador: (): FieldComponent => ({
      is: Component.Render,
    }),
    nroFiscal: (): FieldComponent => ({
      is: Component.Render,
    }),
    ocorrencia: (): FieldComponent => ({
      is: Component.Render,
    }),
    auditoria: (): FieldComponent => ({
      is: Component.Render,
    }),
    comMotorista: (): FieldComponent => ({
      is: Component.Render,
    }),
    idMotorista: (): FieldComponent => ({
      is: Component.Render,
    }),
    idStatus: (): FieldComponent => ({
      is: Component.Render,
    }),
    slaPendente: (): FieldComponent => ({
      is: Component.Render,
    }),
    cep: (): FieldComponent => ({
      is: Component.Render,
    }),
    uf: (): FieldComponent => ({
      is: Component.Render,
    }),
    cidade: (): FieldComponent => ({
      is: Component.Render,
    }),
    cte: (): FieldComponent => ({
      is: Component.Render,
    }),
    idOcorrencia: (): FieldComponent => ({
      is: Component.Render,
    }),
    start: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.start),
      },
    }),
    end: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.end),
      },
    }),
  }
}
